// User
export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const SET_USER = 'SET_USER'
export const REFRESHON = 'REFRESHON'
export const REFRESHOFF = 'REFRESHOFF'
export const REFRESHTOKEN = 'REFRESHTOKEN'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'


// Settings
export const SHOW_LOADING = 'SHOW_LOADING'
export const SET_THEME = 'SET_THEME'
export const HIDE_LOADING = 'HIDE_LOADING'
export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'


// Tasks
export const SET_TODOS = 'SET_TODOS'


// Documents
export const SET_OPENED_DOCUMENT = 'SET_OPENED_DOCUMENT'

// Enrollment
export const SET_ENROLLMENT_PRODUCT = 'SET_ENROLLMENT_PRODUCT'
export const CLEAR_ENROLLMENT_PRODUCT = 'CLEAR_ENROLLMENT_PRODUCT'

// Course Curriculum
export const FETCH_CURRICULUM_REQUEST = 'FETCH_CURRICULUM_REQUEST'
export const FETCH_CURRICULUM_SUCCESS = 'FETCH_CURRICULUM_SUCCESS'
export const FETCH_CURRICULUM_FAILURE = 'FETCH_CURRICULUM_FAILURE'
export const CLEAR_CURRICULUM_ERROR = 'CLEAR_CURRICULUM_ERROR'
